function getError (action, option, xhr) {
  let msg
  if (xhr.response) {
    msg = `${xhr.response.error || xhr.response}`
  } else if (xhr.responseText) {
    msg = `${xhr.responseText}`
  } else {
    msg = `fail to post ${action} ${xhr.status}`
  }

  const err = new Error(msg)
  err.status = xhr.status
  err.method = 'post'
  err.url = action
  return err
}

function getBody (xhr) {
  const text = xhr.responseText || xhr.response
  if (!text) {
    return text
  }

  try {
    return JSON.parse(text)
  } catch (e) {
    return text
  }
}

let uploadXHR

function httpRequest (option) {
  return new Promise((resolve, reject) => {
    if (typeof XMLHttpRequest === 'undefined') {
      reject('不支持XMLHttpRequest')
    }

    const xhr = new XMLHttpRequest()
    const action = option.action
    const method = option.method || 'GET'

    xhr.onerror = function error (e) {
      reject(e)
    }

    xhr.onload = function onload () {
      if (xhr.status < 200 || xhr.status >= 300) {
        reject(getError(action, option, xhr))
      }
      resolve(getBody(xhr))
    }
    // 处理请求参数params
    let search = ''
    // FormData不作处理
    if (option.params instanceof FormData) {
      search = option.params
    } else if (typeof (option.params) === 'string') {
      search = option.params
    } else {
      var params = []
      for (var key in option.params) {
        params.push(key + '=' + encodeURIComponent(option.params[key]))
      }
      search = params.join('&')
    }
    // if (option.params && typeof option.params === 'object') {
    //   const keys = Object.keys(option.params)
    //   keys.forEach(item => {
    //     if (option.params[item] || option.params[item] === 0) {
    //       search += '&' + item + '=' + option.params[item]
    //     }
    //   })
    // }

    const url = action + '?' + search

    if (option.withCredentials && 'withCredentials' in xhr) {
      xhr.withCredentials = true
    }

    const headers = option.headers || {}

    if (method.toUpperCase() === 'POST') {
      xhr.open(method, action, true)
      // setHeader 应改 open 方法后边
      for (let item in headers) {
        if (headers.hasOwnProperty(item) && headers[item] !== null) {
          xhr.setRequestHeader(item, headers[item])
        }
      }
      if (option.params instanceof FormData) {
        // FormData
      } else {
        xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded;charset=utf-8')
      }
      xhr.send(search)
    }
    if (method.toUpperCase() === 'GET') {
      xhr.open('GET', url, true)
      // setHeader 应改 open 方法后边
      for (let item in headers) {
        if (headers.hasOwnProperty(item) && headers[item] !== null) {
          xhr.setRequestHeader(item, headers[item])
        }
      }
      xhr.send(null)
    }
    uploadXHR = xhr
  })
}

export {
  uploadXHR,
  httpRequest
}



// WEBPACK FOOTER //
// ./src/utils/ajax.js